import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import { isLineApp } from './utils/userAgent';

// 運用ルール:
// - LINE_RELOAD_STATE_KEY は原則固定（保存先キー名のため）
// - LINE_RELOAD_BUILD_ID は再読み込みを実行したいリリース時のみ更新
//   例: '2026-05-05-13'
const LINE_RELOAD_STATE_KEY = 'zenb-subscription:line-reload:v1';
const LINE_RELOAD_BUILD_ID = '2026-04-27-01';

type LineReloadState = {
  schema: 1;
  buildId: string;
  reloadedAt: number;
};

// LINE 内ブラウザでは、buildId が変わったタイミングで 1 回だけ再読み込みする
if (isLineApp()) {
  const storage = getAvailableStorage();
  if (storage) {
    const state = readLineReloadState(storage, LINE_RELOAD_STATE_KEY);
    const needsReload = !state || state.buildId !== LINE_RELOAD_BUILD_ID;
    if (needsReload) {
      writeLineReloadState(storage, LINE_RELOAD_STATE_KEY, {
        schema: 1,
        buildId: LINE_RELOAD_BUILD_ID,
        reloadedAt: Date.now(),
      });
      window.location.reload();
    }
  }
}

function getAvailableStorage(): Storage | null {
  if (canUseStorage(window.localStorage)) return window.localStorage;
  if (canUseStorage(window.sessionStorage)) return window.sessionStorage;
  return null;
}

function canUseStorage(storage: Storage): boolean {
  try {
    const probeKey = '__zenb_storage_availability_probe__';
    storage.setItem(probeKey, '1');
    storage.removeItem(probeKey);
    return true;
  } catch {
    return false;
  }
}

function readLineReloadState(storage: Storage, key: string): LineReloadState | null {
  try {
    const raw = storage.getItem(key);
    if (!raw) return null;

    const parsed = JSON.parse(raw) as Partial<LineReloadState>;
    if (parsed.schema !== 1) return null;
    if (typeof parsed.buildId !== 'string') return null;
    if (typeof parsed.reloadedAt !== 'number') return null;

    return {
      schema: 1,
      buildId: parsed.buildId,
      reloadedAt: parsed.reloadedAt,
    };
  } catch {
    return null;
  }
}

function writeLineReloadState(storage: Storage, key: string, state: LineReloadState): void {
  try {
    storage.setItem(key, JSON.stringify(state));
  } catch {
    // Storage に書き込めない環境では何もしない
  }
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();